import {mapState, mapGetters} from 'vuex';
import moment from 'moment';
import diacritics from 'diacritics';
import _ from 'lodash';
import cities from './store/cities';

let removeDiacritics = diacritics.remove;
let baseYear = 2015;
let currentYear = moment().year();
let dynamicYearOptions = [];
// a for loop to fill yearOptions list with 2015 to current year dynamically.
for (let index = baseYear; index < currentYear + 2; index++) {
    let yearOption = {};
    yearOption.value = index;
    yearOption.text = index.toString();
    dynamicYearOptions.push(yearOption);
}
export default {
    data() {
        return {
            yearOptions: dynamicYearOptions,
            otherFolderTypes: ['document', 'bill', 'chemical', 'waste'],
            initialState: {
                user: {},
                modal: {
                    eventId: null,
                    type: null,
                    text: null
                },
                data: {
                    tags: [],
                    meta: {},
                    content: {}
                },
                uploadFiles: [],
                documents: [],
                goals: [],
                year: moment().year(),
                audits: [],
                nonconformances: [],
                paymentMethods: [],
                siteId: null,
                sites: [],
                siteTypes: [],
                dataTypes: [],
                sourceTypes: [],
                dashboardDataTypes: [121, 124, 147],
                formTypes: [],
                units: [],
                maxUpdatedAtForDocuments: null,
                maxUpdatedAtForGoals: null,
                maxUpdatedAtForAudits: null,
                cities: cities,
                siteGroups: [],
                sitesWithGroups: [],
                users: [],
                isInitiated: false,
                isMobile: false,
                isTablet: false,
                //locale: 'tr',
                countryMap: {},
                regionMap: {},
                cityMap: {},
                sectorMap: {},
                locationMap: [],
                tagMap: [],
                scopeGroupMap: [],
                sourceTypeGroupMap: [],
                sourceTypeMap: [],
                unitMap: {},
                isExcludedForAws: false,
                // Need production ip address
                /*eslint-disable */
                /* apiURL:
                    process.env.NODE_ENV === 'development'
                        ? 'http://localhost:7788'
                        : 'http://35.205.187.92:7788', */
                token: `Bearer ${localStorage.getItem('token')}`
                /*eslint-enable */
            }
        };
    },
    methods: {
        // If the typed text length lower than 5
        //      --> First, search on item codes
        //      --> Second, If any sites isn't found then start searching from the start of the item name.
        // Otherwise search from any position
        searchOnSites(searchQuery, sites) {
            if (searchQuery.length <= 4) {
                let filteredSites = sites.filter(item => {
                    return this.textStartsWith(String(item.code), searchQuery);
                });

                if (filteredSites.length) {
                    return filteredSites;
                } else {
                    filteredSites = sites.filter(item => {
                        return this.textStartsWith(item.originalName, searchQuery);
                    });

                    if (filteredSites.length) {
                        return filteredSites;
                    }
                }
            }

            return sites.filter(item => {
                let match = this.isSearchTextFound(item.originalName, searchQuery);
                return match && match.length;
            });
        },

        createGroupedSitesKeys(siteIds){
            let filteredSites = _.filter(this.sites, site=>_.includes(siteIds,site.id));
            let filteredSiteMap = [];
            let allSitesFlag = true;

            _.each(this.sitesWithGroups, siteGroup=>{
                let childs = [];

                let regionId = this.getSiteMapCoreId(siteGroup.id);

                let siteData = _.groupBy(filteredSites.filter(s => s.siteGroupId === regionId), 'cityCode');

                let allCitiesFlag = true;

                _.each(siteData, (sites,cityId)=>{
                    let citySites = [];
                    _.each(sites, site=>{
                        citySites.push("site-"+_.toString(site.id));
                    });

                    let cityKey = "city-"+regionId+"-"+cityId;
                    let city = _.head(_.filter(siteGroup.children, o=>o.id==cityKey));
                    if(city === undefined){
                        childs = _.concat(childs, citySites);
                    }
                    else{
                        if(_.size(city.children) == _.size(citySites)){
                            childs.push(city.id);
                        }
                        else{
                            childs = _.concat(childs, citySites);
                            allSitesFlag = false;
                            allCitiesFlag = false;
                        }
                    }
                });

                if(_.size(childs) == _.size(siteGroup.children) && allCitiesFlag){
                    filteredSiteMap.push(siteGroup.id);
                }

                else{
                    filteredSiteMap = _.concat(filteredSiteMap, childs);
                    allSitesFlag = false;
                }
            });

            if(allSitesFlag){
                filteredSiteMap = ['All'];
            }

            return filteredSiteMap;
        },
        getSiteIdsInGroupedSitesMap(groupedSitesKeys){
            let siteIds = [];

            if(_.includes(groupedSitesKeys, 'All')){
                siteIds = _.map(this.sites, 'id');
            }else{
                _.each(groupedSitesKeys, siteKey=>{
                    let keyParts = siteKey.split('-');
                    if(keyParts[0] == "site"){
                        siteIds.push(_.toNumber(keyParts[1]));
                    }
                    else if(keyParts[0] == "city"){
                        siteIds = _.concat(siteIds, _.map(this.sites.filter(s => (s.siteGroupId === _.toNumber(keyParts[1]) && _.toNumber(s.cityCode) === _.toNumber(keyParts[2]))), 'id'));
                    }
                    else{
                        siteIds = _.concat(siteIds, _.map(this.sites.filter(s => s.siteGroupId === _.toNumber(keyParts[1])), 'id'));
                    }
                });
            }

            return siteIds;
        },
        getSiteMapCoreId(key){
            let parts = key.split('-');
            return _.toNumber(parts[1]);
        },
        routeToDashboard(selectedSiteId, year) {
            let query = {
                year: year
            };
            if (selectedSiteId) {
                query.site_id = selectedSiteId;
            }
            this.$router.push({name: 'dashboard', query});
            return Promise.resolve();
        },
        downloadFile(url) {
            if(_.includes(url, 'http')){
                window.open(url, '_blank');
            }
            else{
                window.open(`${this.apiURL}/${url}`, '_blank');
            }
        },
        showWarnModal(target, text) {
            this.$store.commit('SET_MODAL', {
                eventId: String(+new Date()),
                type: 'warn',
                text: text ? text : 'Silmek istediğinize emin misiniz?'
            });
            this.$nextTick(() => {
                this.$root.$emit('bv::show::modal', 'warn', target);
            });
        },
        showNotificationModal(text){
            this.$store.commit('SET_MODAL', {
                eventId: String(+new Date()),
                type: 'notification',
                text: text ? text : 'Bu işlem biraz vakit alabilir lütfen bekleyiniz.'
            });
            this.$nextTick(() => {
                this.$root.$emit('bv::show::modal', 'notification');
            });
        },
        showErrorNotification(text) {
            this.$notify({
                group: 'info',
                title: this.$t('went-wrong'),
                text,
                type: 'error'
            });
        },
        generateInRange(start, end) {
            return Array.from({length: end - start}, (v, k) => k + start);
        },
        textStartsWith(target, input) {
            target = removeDiacritics(target.toLowerCase());
            input = removeDiacritics(input.toLowerCase());
            return target.startsWith(input);
        },
        isSearchTextFound(target, input) {
            target = removeDiacritics(target.toLowerCase());
            input = removeDiacritics(input.toLowerCase());
            return target.match(input);
        },
        isRegionFound(targetId, inputId) {
            return !targetId || targetId === inputId;
        },
        isAgentFound(target, inputId) {
            let agentId = _.nth(target, 0);
            if (inputId == 1 && agentId == null) {
                return true;
            } else {
                return false;
            }
        },
        convertToLocalizedFloat(value, locale, digitCount = 2) {
            if (locale === 'tr') {
                return Number(value)
                    .toFixed(digitCount)
                    .replace('.', ',');
            }
            return Number(value).toFixed(digitCount);
        },
        localizeValue(value, locale) {
            if (locale === 'tr') {
                return value.replace(/\,/gi, '-').replace(/\./gi, ',').replace(/\-/gi, '.');
            }
            return value;
        },
        delocalizeValueForBN(value, locale) {
            if (locale === 'tr') {
                return value.replace(/\./gi, '-').replace(/\,/gi, '.').replace(/\-/gi, ',');
            }
            return value;
        },
        delocalizeValue(value, locale) {
            if (locale === 'en') {
                return value.replace(/\./gi, '-').replace(/\,/gi, '.').replace(/\-/gi, ',');
            }
            return value;
        },
        convertToNumber(str) {
            return (
                Number(
                    _.toString(str)
                        .replace(/\./gi, '')
                        .replace(',', '.')
                ) || 0
            );
        },
        // remove trailing zeors in float numbers
        removeZeros(val) {
            val = val.replace(/\./gi, '').replace(',', '.').split('.');

            if(val[1]) {
                val[1] = val[1].replace(/0+$/g, '');
            } 

            return val.join('.');
        },
        // get group names for different customers
        getGroupName(groupName){
            if(groupName == 'agent'){
                return this.isbId(this.$store.state.user.customerId) 
                ? 'isb_agent'
                : 'agent';
            } else if(groupName == 'subAgent') {
                return this.isbId(this.$store.state.user.customerId) 
                ? 'technician'
                : 'sub-agent';
            } else if(groupName == 'supervisor') {
                return this.isbId(this.$store.state.user.customerId) 
                ? 'isb_supervisor'
                : 'supervisor';
            }
            else {
                return groupName;
            }
        },
        getLastFilledProperty(site, type) {
            let property = null;
            let years = this.generateInRange(2015, this.year + 1).reverse();
            if (!site.yearlyProperties[this.year] || !site.yearlyProperties[this.year][type]) {
                years.forEach(year => {
                    if (
                        !property &&
                        site.yearlyProperties[year] &&
                        site.yearlyProperties[year][type]
                    ) {
                        property = site.yearlyProperties[year];
                    }
                });
            } else {
                property = site.yearlyProperties[this.year];
            }
            return property;
        },
        deepClone(data) {
            return JSON.parse(JSON.stringify(data));
        },
        getInitialState(state) {
            Object.assign(state, this.initialState);
        },
        createUTCDate(year, month, day) {
            return new Date(Date.UTC(year, month, day));
        },
        isMaster(customerId){
            return customerId == 23;
        },
        isbId(customerId){
            return customerId == -1;//3042;
        },
        gbId(customerId){
            return customerId == -1;//1;
        },
        downloadExcelBlob(data,filename){
            var blob = new Blob([data.data], {type: 'application/vnd.ms-excel'});
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
        },
        canGetReport() {
            return this.$store.state.user.permissions.canGetReport;
        },
        toLocaleLowerCase(val) {
            const langMap = {
                en: 'en-US',
                tr: 'tr'
            };

            return val.toLocaleLowerCase(langMap[this.$store.state.user.language]);
        }
    },
    computed: {
        ...mapState([
            'route',
            'apiURL',
            'token',
            'sites',
            'siteGroups',
            'sitesWithGroups',
            'year',
            'uploadFiles',
            'documents',
            'locale',
            'maxUpdatedAtForDocuments',
            'maxUpdatedAtForGoals',
            'audits',
            'maxUpdatedAtForAudits',
            'paymentMethods',
            'formTypes',
            'siteTypes',
            'countryMap',
            'regionMap',
            'cityMap',
            'sectorMap',
            'locationMap',
            'tagMap',
            'scopeGroupMap',
            'sourceTypeGroupMap',
            'sourceTypeMap',
            'unitMap',
            'isExcludedForAws'
        ]),
        ...mapGetters(['maskOfNumber', 'maskOfEmission', 'maskOfCurrency'])
    }
};



// WEBPACK FOOTER //
// ./src/mixin.js